import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type DataConnectorsProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const DataConnectors = ({ size = 24, width, height, alt = '', style, ...props }: DataConnectorsProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(0.78431373 0 0 0.78431373 -1.33333333 -1.07124183)',
        },
        [
          h(
            'path',
            {
              d: 'M29.75 12.6667V16.6667C29.75 19.98 24.0408 22.6667 17 22.6667C9.95917 22.6667 4.25 19.98 4.25 16.6667V12.6667C4.25 15.98 9.95917 18.6667 17 18.6667C24.0408 18.6667 29.75 15.98 29.75 12.6667ZM4.25 19.3333C4.25 22.6467 9.95917 25.3333 17 25.3333C24.0408 25.3333 29.75 22.6467 29.75 19.3333V23.3333C29.75 26.6467 24.0408 29.3333 17 29.3333C9.95917 29.3333 4.25 26.6467 4.25 23.3333V19.3333ZM17 16C9.95917 16 4.25 13.3133 4.25 10C4.25 6.68667 9.95917 4 17 4C24.0408 4 29.75 6.68667 29.75 10C29.75 13.3133 24.0408 16 17 16Z',
              fill: '#2F54EB',
            },
          ),
        ],
      ),
    ],
  );

export default DataConnectors;
